import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import theme from '../../styles/theme';
const defaultProps = {
    above: '',
    below: '',
    className: '',
};
const ShowAt = ({ above = defaultProps.above, below = defaultProps.below, children, className = defaultProps.className, }) => (_jsx("div", Object.assign({ className: className, css: css `
        display: none;
        ${above &&
        theme.media.greaterThan(above) `
          display: block;
        `}
        ${below &&
        theme.media.lessThan(below) `
          display: block;
        `}
      ` }, { children: children })));
const MemoizedShowAt = memo(ShowAt);
export { MemoizedShowAt as ShowAt };
// MC-1068 Temporary hack for Storybook.
export default ShowAt;
